import React from 'react';
import CollapsibleSection from './components/CollapsibleSection';

function RedditList({ posts }) {
  return (
    <CollapsibleSection title="Reddit Insights">
      {Array.isArray(posts) && posts.length > 0 ? (
        posts.map((post, idx) => (
          <div className="reddit-post" key={idx}>
            <h3>
              <a href={post.url} target="_blank" rel="noopener noreferrer">
                {post.title}
              </a>
            </h3>
            <div className="post-meta">
              <span className="subreddit">r/{post.subreddit}</span>
              <span>
                <i className="fas fa-arrow-up"></i> {post.score} points
              </span>
              <span>
                <i className="fas fa-comments"></i> {post.num_comments} comments
              </span>
            </div>
            {post.selftext && (
              <p className="post-content">
                {post.selftext.length > 200 
                  ? `${post.selftext.substring(0, 200)}...` 
                  : post.selftext}
              </p>
            )}
          </div>
        ))
      ) : (
        <div className="no-results">
          <p>No Reddit discussions found for this topic.</p>
          <p className="text-muted">Try broadening your search criteria or check back later.</p>
        </div>
      )}
    </CollapsibleSection>
  );
}

export default RedditList;
